import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommentComponent } from "../comment/comment.component";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-flow-thank-you",
  templateUrl: "./flow-thank-you.component.html",
  styleUrls: ["./flow-thank-you.component.scss"],
})
export class FlowThankYouComponent implements OnInit {
  flowData: any;
  userData: any;
  contentType: "flow" | "bundle" = "flow";

  constructor(
    public dialogRef: MatDialogRef<FlowThankYouComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private authModalService: AuthModalService,
    private router: Router
  ) {
    this.flowData = data.flowData;
    this.contentType = data?.contentType === "bundle" ? "bundle" : "flow";
  }

  get contentTypeLabel(): string {
    return this.contentType === "bundle" ? "bundle" : "flow";
  }

  ngOnInit() {
    const loggedInUser = localStorage.getItem("LoggedInUser");
    this.userData = loggedInUser ? JSON.parse(loggedInUser) : null;
  }

  close() {
    this.dialogRef.close();
  }

  openCommentModal() {
    if (this.userData != null) {
      if (this.contentType === "bundle") {
        localStorage.setItem("bundlecommentData", JSON.stringify(this.flowData));
        localStorage.removeItem("flowcommentData");
        localStorage.setItem("FromBundleData", "yes");
      } else {
        localStorage.setItem("flowcommentData", JSON.stringify(this.flowData));
        localStorage.removeItem("bundlecommentData");
      }
      const dialogRef = this.dialog.open(CommentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {
        // Comment modal closed
      });
    } else {
      this.authModalService.openModal('registration', this.router.url);
    }
  }
}


